<div class="gw-rd-page-widget-container">
    <slot />
</div>

<style lang="postcss">
    .gw-rd-page-widget-container {
        max-width: 1600px;
        height: 100%;
        margin: 0 auto;
        padding: clamp(var(--gw-rd-space-15), 6vw, var(--gw-rd-space-30))
            clamp(var(--gw-rd-space-8), 4vw, var(--gw-rd-space-25));
        box-sizing: border-box;
    }
</style>
